/**
 * A thread full screen (a phone, docs/design/visual-overhaul.md §12): its
 * own main pane with the thread panel's header over the thread's
 * conversation. Back (the pane's, the edge swipe, the system's) returns to
 * its channel. Wider windows show the thread beside its channel instead
 * (ChannelView's slot).
 */
import type { Channel } from '@neosocial/protocol';
import { ChannelView } from '../hub/ChannelView';
import { usePanes } from '../shell/panes';
import { useThreadBack } from './entry';
import { ThreadPanel } from './ThreadPanel';

export function ThreadPage({ thread }: { thread: Channel }) {
  useThreadBack(
    thread,
    usePanes((p) => p.pane === 'main'),
  );
  return (
    <section className="hub-pane nx-panel ns-th-page" aria-label={thread.name ?? ''}>
      <ThreadPanel threadId={thread.id}>
        <ChannelView key={thread.id} channelId={thread.id} embedded inThread />
      </ThreadPanel>
    </section>
  );
}
